import { render, staticRenderFns } from "./gitRawFile.vue?vue&type=template&id=800e2df4&"
import script from "./gitRawFile.vue?vue&type=script&lang=js&"
export * from "./gitRawFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports